<dropdown-v2
  [items]="items"
  [selectedItem]="selectedItem"
  [attr.data-id]="field.key"
  [placeholder]="props.label || ''"
  (itemSelect)="select($event)"
/>
